export default class ProjectPricingItem {
  constructor(item) {
    if (item === undefined) {
      this.CountryId = '';
      this.OfficeId = '';
      this.ServiceId = ProjectPricingItem.getServiceNumber();
    } else {
      this.CountryId = item.countryId;
      this.OfficeId = item.officeId;
      this.ServiceId = ProjectPricingItem.getServiceNumber();
    }
  }

  static getServiceNumber() {}

  static NameOfTheIdField() {
    return '';
  }

  static nameOfTheItemDetailList() {
    return 'Project Pricing';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [];
  }
}
